// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"314":"orderdetail","377":"purchases","594":"about"}[chunkId] || chunkId) + "." + {"314":"ed87438e","377":"2eb5f9fb","428":"ccb524e3","594":"90d1901c"}[chunkId] + ".css";
};